import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { RootState } from 'store/root-reducer';
import { AppDispatch } from 'store/store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
